
import * as types from './mutations_type';

export default {
  // [types.SET_ENV]: (s, env) => {
  //   s.env = env;
  // },
  // [types.SET_UI_MODULES]: (s, modules) => {
  //   s.uiModules = modules;
  // },
  [types.SET_USER_INFO]: (s, userInfo) => {
    s.userInfo = userInfo;
  },
  [types.SET_ENTERPRISE_ID]: (s, id) => {
    s.enterpriseID = id;
    localStorage.setItem('enterprise', id);
  },
  [types.SET_ENTERPRISE_INFO_LIST]: (s, infoList) => {
    s.enterpriseInfoList = infoList;
    localStorage.setItem('enterpriseInfo', JSON.stringify(infoList));
  },
  [types.SET_ORG_LIST]: (s, list) => {
    s.orgAllList = list;
    localStorage.setItem('orgAllList', JSON.stringify(list));
  },
  [types.SET_ORGID]: (s, id) => {
    s.orgID = id;
    localStorage.setItem('orgId', id);
  },
  [types.SET_ALL_PRODUCTS]: (s, list) => {
    s.allProducts = list;
    // localStorage.setItem('allProducts', JSON.stringify(list));
  },
  [types.SET_PRIV_PRODUCT_IDS]: (s, idArr) => {
    s.privProductIDs = idArr;
    localStorage.setItem('setProduct', JSON.stringify(idArr));
  },
  [types.SET_PRIV_PRODUCTS]: (s, list) => {
    s.privProducts = list;
    localStorage.setItem('products', JSON.stringify(list));
  },
  [types.SET_LICENSE_INFO]: (s, info) => {
    s.licenseInfo = {};
    s.licenseInfo = info;
    localStorage.setItem('licenseInfo', JSON.stringify(info));
  },
  [types.SET_LOCALE]: (s, locale) => {
    s.showLanguage = locale;
    localStorage.setItem('locale', locale);
  },
  [types.SET_PRIVILEGE_LIST]: (s, privilegeList) => {
    s.privilegeList = privilegeList;
  },
  [types.SET_ROBOT_LIST]: (s, robotList) => {
    window.localStorage.setItem('robots', JSON.stringify(robotList));
    s.robotList = {};

    robotList.forEach((robot) => {
      s.robotList[robot.id] = robot;
    });

    if (Object.keys(s.robotList).indexOf(s.appid) < 0) {
      s.appid = '';
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js